import classNames from 'classnames'
import FieldError from './FieldError';

function CheckboxField({field, displayErrors}) {

  const error = field.error[0];
  
  return (
  <div className="o-form-fieldset o-form-label-top">
    <div className={classNames('o-form-input', { 'o-form-has-errors': true })}>
      <span className={classNames('o-form-input-name-food', 'o-form-control', 'okta-form-input-field', { 'o-form-has-errors': true })}>
        <label className="hcl-checkbox">
          <input type="checkbox" checked={field.property[0]} readOnly={true} onClick={() => field.property[1](!field.property[0])}/>
          <span style={{marginLeft: "5px"}}>{field.label()}</span>
        </label>
      </span>
      {error && displayErrors && (
        <FieldError msg={error}/>
      )}
    </div>
  </div>)
}

export default CheckboxField;
